import { render } from "./OtherPersonels.vue?vue&type=template&id=5fdebb1a&scoped=true"
import script from "./OtherPersonels.vue?vue&type=script&lang=js"
export * from "./OtherPersonels.vue?vue&type=script&lang=js"

import "./OtherPersonels.vue?vue&type=style&index=0&id=5fdebb1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fdebb1a"]])

export default __exports__